// Delegated listeners also cover headers re-rendered by Shopify's theme editor.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  for (const menu of document.querySelectorAll('.sl-mobile[open]')) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.sl-mobile[open]');
  if (!menu) return;
  menu.removeAttribute('open');
  menu.querySelector('summary')?.focus();
});
